import React, { useState } from "react";

interface FAQ {
  id: number;
  question: string;
  answer: string;
}

interface FAQsPageProps {
  invitation: any;
}

const FAQsPage: React.FC<FAQsPageProps> = ({ invitation }) => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs: FAQ[] = [
    {
      id: 1,
      question: "What should I wear to the wedding?",
      answer:
        "The dress code is semi-formal. Please feel free to wear whatever color you prefer. (Even white!)",
    },
    {
      id: 2,
      question: "Can I bring a plus one?",
      answer:
        "Plus ones are welcome if specified on your invitation. Please check your invitation details or contact us if you have questions about bringing a guest.",
    },
    {
      id: 3,
      question: "Are children welcome at the wedding?",
      answer:
        "We love your kids, and would love to see them another time, but we've chosen to make our wedding 16+.",
    },
    {
      id: 4,
      question: "Can I take photos during the ceremony?",
      answer:
        "We kindly ask that you refrain from taking photos during the ceremony. Our professional photographer will capture all the special moments, and we'll share the photos with you afterward.",
    },
    {
      id: 5,
      question: "Can I take photos during the reception?",
      answer:
        "You are welcome to take pictures during the reception, but we kindly ask that you don't spend the entire time behind your camera. We have a professional photographer capturing the special moments, and we'd love for you to be fully present and enjoy the celebration.",
    },
    {
      id: 6,
      question: "Can I post the photos I took during the reception?",
      answer:
        "Please wait for us to share our official photos before posting any pictures on social media.",
    },
    {
      id: 7,
      question: "Where can I find the registry?",
      answer:
        "We've created a registry with some special items we've selected, along with our main registry on Amazon. You can find everything by clicking on the 'Registry' tab above.",
    },
  ];

  const toggleFAQ = (id: number) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="faqs-page">
      <div className="faqs-container">
        <h2>Frequently Asked Questions</h2>
        <div className="faqs-list">
          {faqs.map((faq) => (
            <div key={faq.id} className="faq-item">
              <button
                className={`faq-question ${openFAQ === faq.id ? "open" : ""}`}
                onClick={() => toggleFAQ(faq.id)}
              >
                {faq.question}
                <span className="faq-toggle">
                  {openFAQ === faq.id ? "−" : "+"}
                </span>
              </button>
              <div className={`faq-answer ${openFAQ === faq.id ? "open" : ""}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQsPage;
